import React from "react";
import "./styles.scss";

const PaymentCard = ({
  dataContainerBgColor = "bg-danger-100",
  statusContainerBgColor = "bg-danger-100",
  dayTextColor = "neutral-900",
  monthTextColor = "text-danger-700",
  paymentStatusTextColor = "text-danger-700",
  dayText,
  monthText,
  paymentPeriodText,
  paymentAmountText,
  icon,
  paymentStatusText,
  isLastItem,
  isRounded = true,
  onClick,
}) => {
  return (
    <div
      className={`payment-card-container ${isLastItem && "border-bottom-0"} ${
        isRounded && "payment-card-container-is-rounded"
      }`}
      onClick={onClick}
    >
      <div className={"payment-info-wrapper"}>
        <div className={`date-container ${dataContainerBgColor}`}>
          <span className={`day-text ${dayTextColor}`}>{dayText}</span>
          <span className={`month-text ${monthTextColor}`}>{monthText}</span>
        </div>
        <div className={"payment-detail-wrapper"}>
          <span className="payment-period-text">{paymentPeriodText}</span>
          <span className="payment-amount-text">{paymentAmountText}</span>
        </div>
      </div>

      <div className={`payment-status-container ${statusContainerBgColor}`}>
        <div className={"status-container"}>
          <img src={icon} className="payment-status-icon" alt="" />
          <spna className={`payment-status-text ${paymentStatusTextColor}`}>
            {paymentStatusText}
          </spna>
        </div>
      </div>
    </div>
  );
};

export default PaymentCard;
